<template>
  <div class="lrp-retailer" :class="[productDesbutton ? '' : ' cell']">
    <!-- <div ref="popupContainerOuter1" >qw</div> -->
    <div class="buyOnline -btnOnly" v-if="!stickyBuynowButton">
      <div @click="buybuttonselect()" class="popupContainer__bagIcon popupContainer__bagIcon_buy">
        <img alt="bag" src="/frontend/master/images/icons/bag--black.svg">
      </div>
      <button :class="!ctaClass ? ctaClass : 'cta cta--light actionBtn buyOnline'" @click="buybuttonselect()">
        <span class=" btn__wrapper ">
          {{ dataTextLable }} 
        </span>
      </button>
    </div>
    <div v-else-if="(stickyBuynowButton && !smallScreen) || (stickyBuynowButton && oneVariant)">
      <button type="button" class="actionBtn buyOnline" @click="buybuttonselect()"> {{ dataTextLable }} </button>
    </div>
    <div v-if="stickyBuynowButton && smallScreen && oneVariant === false">
      <button type="button" class="actionBtn buyOnline" @click="mobilebuybutton()"> {{ dataTextLable }} </button>
    </div>
    <div class="popupContainerOuter-overlay" :class="{ 'showPopup': showPopup }"></div>
    <div class="popupContainerOuter popupWrapper" id="popupContainerOuter"  :class="{ 'showPopup': showPopup }" >
      <div class="popupRetailer">
        <div class="popup-title__container">
          <h2 class="popup-heading"> <span v-if="initialData.enableBuynowSortOption">{{initialData.retailerDictionaryDatas.buyOnline}}</span></h2>
          <button ref="accessibilitybtn" class="popupCLose" @click="closePopupScreen()" tabindex="0"></button>
        </div>
        <h3 class="popup-slectShop" v-if="initialData.enableBuynowSortOption && retailerdata.length > 0 && initialData.retailerDictionaryDatas.selectShop">{{initialData.retailerDictionaryDatas.selectShop}}</h3>
         <div class="popup-country__container" v-if="initialData.IsCountryWiseRetailerEnabled && initialData.Countries.length">
          <h2 class="popup-heading"> {{initialData.retailerDictionaryDatas.selectCountry}}</h2>
          <div class="popup-retailer__country">
            <select  v-model="selectedCountry">
              <option    v-for="(item, index) in initialData.Countries"  :key="index" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="retailer-sorting__container" v-if="initialData.enableBuynowSortOption && retailerdata.length > 0">

          <customSorting ref="retailer_sorting" :sortlabel="initialData.retailerDictionaryDatas.sortBy" :options="initialData.retailerDictionaryDatas.sortByOptions" :default="initialData.retailerDictionaryDatas?.defaultText" class="select"
            @getInput="sortOrder = $event" />
        </div>

        <div class="retailer-count" v-if="initialData.enableBuynowSortOption && retailerdata.length > 0 && sortedItems.length > 0">{{sortedItems.length}} {{initialData.retailerDictionaryDatas.onlineShoping}}</div>

       <div v-if="initialData.IsCountryWiseRetailerEnabled ? countryFilteredRetailers.length > 0 : sortedItems.length > 0">
          <div class="retailer-shop__container"  v-for="(retailer, index) in (initialData.IsCountryWiseRetailerEnabled ? countryFilteredRetailers : sortedItems)"    :key="retailer.id || index">
                  <div class="retailer-shop-wrapper">
                    <div class="retailer-shop-img">
                      <img :src="retailer.RetailerImage" :alt="retailer.ProductRetailerItemName" width="130" height="70" />
                    </div>
                    <div class="retailer-shop-name-wrapper">
                      <span class="retailer-name" v-if="retailer.CTALabel"> {{ retailer.name }}</span>
                      <span class="retailer-price" v-if="retailer.price">{{retailer.price}}</span>
                    </div>
                  </div>
                  <div class="retailer-shop-instock" v-if="retailer.stockAvailability">
                    {{retailer.stockAvailability}}
                  </div>
                  <div class="retailer-shop-deliveryTime" v-if="retailer.deliveryTime">
                  {{initialData.retailerDictionaryDatas.deliveryTimeLabel}}<strong>{{retailer.deliveryTime}}</strong>
                  </div>
                  <div class="retailer-shop-buyNow">
                    <a :href="retailer.RetailerLink" rel="nofollow noopener noreferrer"
                      @click="gatagging(retailer.AddToCartTags, retailer.WhereToBuyTags, retailer.ProductRetailerItemName, index)"
                      target="_blank" class="cta cta--light" panel-focusable=""> {{ retailer.CTALabel }}</a>

                  </div>
                </div>
        </div>       
         <div v-else>
            <p class="no-product" style="text-align: center;">{{ errorMessgage }}</p>
         </div>
      </div>
     


    </div>

    <div class="popupContainerOuter variantPopupOuter capacityPopupContainerOuterroutine"
      id="capacityPopupContainerOuter" v-show="capacityPopup" :class="{'capacityPopup' : capacityPopup}">
      <div class="variant popupContainer">
        <div class="popupContainer__close" @click="closecapacityPopupScreen()">&#10006;</div>
        <div class="container pdp-stikcy-bar" id="app">
          <div class="sticky-parent">
            <div class="sticky__heading">
              <img :src="productImg" alt="product images">
            </div>
            <div class="sticky__select">
              <div class="sticky__title" v-html="pfdTitle" />
              <div class="sticky__select--select_capacity">
                <volume-variant-v2 :volumes="volumesDetail" :legend-name="capacityText"
                  a11y-aria-label="legendCurrentVolume" :sfccvolumesdetails="variantDetail" :popup-dropdown="true"
                  :productid="productIds" />
              </div>
              <div class="sticky__select--select_color" v-if="colorList.length > 0">
                <color-variant-v2 a11y-close-panel-text="panelText" a11y-next-panel-text="nextPanelText"
                  a11y-previous-panel-text="previousPanelText" :colors="colorList" :legend-name="colorText"
                  itemprop="color" :productid="productIds" :sfcccolorsdetails="colorsDetails" :popup-dropdown="true" />
              </div>
            </div>
          </div>
          <div class="sticky__buynow-button">
            <button type="button" class="actionBtn buyOnline" @click="buybuttonselect(true)"> {{ dataTextLable }} </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import customSorting from '@Feature/CustomSorting/custom-sorting.vue';
import { tag } from '@Foundation/analyticsHandler';
import Panel from '@Feature/Panel/code/Scripts/components/panel.vue';
import Slide from '@Feature/Slider/code/Scripts/components/slide/slide';
import Slider from '@Feature/Slider/code/Scripts/components/slider/slider';
import ColorVariantV2 from '@Feature/ColorVariant-V2/code/Scripts/components/color-variant-v2';
import VolumeVariantV2 from '@Feature/VolumeVariant-V2/code/Scripts/components/volume-variant-v2';

export default {
  name: 'lrp-retailer',
  components: {
    Panel,
    Slide,
    Slider,
    ColorVariantV2,
    VolumeVariantV2,
    customSorting,
  },
  directives: {
    tag
  },
  props: {
    dataBynowTagging: { type: Object, required: true },
    initialData: { type: Object, required: false },
    dataVariantEan: { type: String, required: false },
    dataTextLable: { type: String, required: false, default: 'Buy Now' },
    a11yNextPanelText: { type: String, required: false, default: 'Next panel' },
    a11yPreviousPanelText: { type: String, required: false, default: 'Previous panel' },
    errorMessgage: { type: String, required: false, default: '' },
    stickyBuynowButton: { type: Boolean, required: false, default: false },
    pfdTitle: { type: String, required: false, default: '<strong>TOLERIANE</strong> <br/> SENSITIVE <br/>LE TEINT CREME' },
    productImg: { type: String, required: false, default: '' },
    activeColor: { type: String, required: false, default: '#009FE3' },
    variantDetail: { type: Array, required: false, default: [] },
    volumesDetail: { type: Array, required: false, default: [] },
    colorsDetails: { type: Array, required: false, default: [] },
    colorList: { type: Array, required: false, default: [] },
    productIds: { type: Array, required: false, default: [] },
    productName: { type: String, required: false, default: '' },
    tagEvent: { type: Boolean, required: false, default: false },
    routineProduct: { type: Boolean, required: false, default: false },
    capacityText: { type: String, required: false, default: 'Capacity' },
    colorText: { type: String, required: false, default: 'Color' },
    productId: { type: String, required: false, default: '' },
    productEan: { type: String, required: false, default: '' },
    productDesbutton: { type: Boolean, required: false, default: false },
    routineProductDektop: { type: Boolean, required: false, default: false },
    routineProductMobile: { type: Boolean, required: false, default: false },
    oneVariant: { type: Boolean, required: false, default: false },
    ctaClass: { type: String },
    navTaggingLabel: { type: [String, Array], required: false, default: '' },
    pageCategory: { type: String, required: false, default: 'page category' },
    legendCurrentVolume: { type: String, required: false, default: 'legend-volume current-volume' },

  },
  data() {
    return {
      sortField:'ProductRetailerItemName',
      capacityPopup: false,
      eretailer: [],
      eretailerlist: [],
      retailerdata: {},
      shopsUnavailable: true,
      showPopup: false,
      show: 0,
      allRetailer: this.initialData.IsPrdAllRetailerEnabled,
      payloadValue: '',
      smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
      eanvalue: '',
      selectedInput: '',
      sortOrder: '',
      selectedCountry: this.initialData?.Countries?.[0] || null,
      variantSelected: '',
    };
  },
  watch: {
    showPopup(newValue) {
      if (newValue) {
        this.sortOrder = '';
       this.$refs.retailer_sorting.selected = this.initialData.retailerDictionaryDatas?.defaultText;

      }
    }
  },
  computed: {
    sortedItems() {
      if (!this.sortOrder) return this.retailerdata;
      return [...this.retailerdata].sort((a, b) => {
        if (this.sortOrder === 'asc') {
          return a[this.sortField].localeCompare(b[this.sortField]);
        } else {
          return b[this.sortField].localeCompare(a[this.sortField]);
        }
      });
    },
    countryFilteredRetailers() {
    if (!this.initialData?.IsCountryWiseRetailerEnabled) return [];
    if (!Array.isArray(this.retailerdata) || this.retailerdata.length === 0) return [];
    const activeCountry = this.selectedCountry || this.initialData.Countries?.[0];
    if (!activeCountry) return this.sortedItems || [];
    const filtered = (this.sortedItems || []).filter(ret => {
      const retailerCountry = ret.Country?.toString().trim().toLowerCase();
      return retailerCountry === activeCountry.toString().trim().toLowerCase();
    });
    
    return filtered.length ? filtered : [];
  
    }


  },
  mounted() {

    if (this.allRetailer === true) {
      this.generatedRetailer(this.initialData.AllRetailersList);
      this.retailerdata = this.eretailerlist;
    }
    if ((this.routineProductDektop && !this.smallScreen) || (this.routineProductDektop && this.oneVariant)) {
      this.buybuttonselect();
    }
    if (this.routineProductMobile) {
      this.mobilebuybutton();
    }

    window.eventBus.$on('selectedVarientSize', payload => {
      this.variantSelected = payload;
      this.eanvalue = payload;
      this.payloadValue = payload;

      if (payload && this.allRetailer === false) {
        this.payloadValue = payload;
        this.sendRequest(payload);
      }
    });

  },
  methods: { 
    generatedRetailer(retailers) {
      if (retailers != null) {
        for (let i = 0; i < retailers.length; i++) {
          this.valueexist(retailers[i]);
        }
      }
    },
    valueexist(retailer) {
      if (this.eretailerlist.length > 1) {
        for (let i = 0; i <= this.eretailerlist.length; i++) {
          if (!this.eretailerlist.some(data => data.ProductRetailerItemName === retailer.ProductRetailerItemName)) {

            this.eretailerlist.push(retailer);
          }
        }
      } else {
        this.eretailerlist.push(retailer);
      }


    },
    gatagging(carttagging, wheretobuytagging, retailername, index) {
      if (carttagging && this.allRetailer === false) {
        window.dataLayer.push({ ...carttagging });
      }
      if (this.allRetailer === true) {
        let currentEan = '';
        if (this.eanvalue == '') {
          currentEan = this.dataVariantEan;
        }
        else {
          currentEan = this.eanvalue;
        }
        for (let i = 0; i < this.initialData.AllRetailersList.length; i++) {
          if (this.initialData.AllRetailersList[i].ProductRetailerItemName === retailername && this.initialData.AllRetailersList[i].VariantEANId === currentEan) {
            window.dataLayer.push({ ...this.initialData.AllRetailersList[i].AddToCartTags });
          }
        }
      }
    },
    /* eslint-disable sonarjs/cognitive-complexity */
    buybuttonselect: function (mobile = null) { 
      if (mobile) {
        this.capacityPopup = false;
      }
      if (this.allRetailer === false) {
        if (this.payloadValue) {
          this.sendRequest(this.payloadValue);
        } else {
          this.sendRequest(this.dataVariantEan);
        }
      }
      if (this.payloadValue === '') {
        this.payloadValue = this.initialData.DefaultEAN;
      }
      if (this.initialData.VariantRetailerList != null && this.initialData.VariantRetailerList.length > 0) {
        for (let i = 0; i < this.initialData.VariantRetailerList.length; i++) {
          if (this.initialData.VariantRetailerList[i].VariantID === this.payloadValue) {
            window.dataLayer.push(this.initialData.VariantRetailerList[i].WhereToBuyTags);
          }
        }
      }

       
      document.querySelector('.sticky-wrapper')?.classList.add('sticky-wrapper__active');
      document.querySelector('.buyOnline').classList.add('buyOnline__active');
      if (this.showPopup) {
        this.showPopup = false
      } else {
        this.showPopup = true;
        if (document.body.classList.contains('is-using-keyboard')) {
          this.$nextTick(() => {
            this.$refs.accessibilitybtn?.focus();
          });
        }
      }
    },
    closePopupScreen() {
    
     
      document.querySelector('.sticky-wrapper')?.classList.remove('sticky-wrapper__active');
      document.querySelector('.buyOnline').classList.remove('buyOnline__active');
      window.eventBus.$emit('lrpretailer', false);
      document.body.style.removeProperty('overflow');
      setTimeout(() => { 
        this.showPopup = false;
      }, 500);
    },
    sendRequest(selectedEan) {
      this.eretailer = [];
      this.retailerdata = '';
      for (let i = 0; i < this.initialData.VariantRetailerList.length; i++) {

        if (this.initialData.VariantRetailerList[i].VariantID == selectedEan) {
          if (this.initialData.VariantRetailerList[i].RetailerList.length > 0) {
            this.retailerdata = this.initialData.VariantRetailerList[i].RetailerList;

          }
        }
      }

    },
    isUsingKeyboard() {
      return document.body.classList.contains('is-using-keyboard');
    },

    a11ySlider() {
      const slidesOnPage = this.$refs.slider.currentPerPage;
      const currentSlide = this.$refs.slider.currentPage;
      /* istanbul ignore else */
      if (this.isUsingKeyboard()) {
        this.activeShade = currentSlide * slidesOnPage;
        this.$nextTick();
      }
    },
    productBuynowTag() {
      window.dataLayer.push({
        'event': 'uaevent',
        'event_name': 'buy_now',
        'ecommerce': 'undefined',
        'eventCategory': 'Ecommerce',
        'eventAction': 'click to buy',
        'eventLabel': `${[this.productName]}::${[this.productEan]}`,
        'product_info': `${[this.productName]}::${[this.productId]}`,
      });
    },
    mobilebuybutton: function () { 
      //this.productBuynowTag();  
         this.capacityPopup = true; 
         this.showPopup = false;
      document.getElementById('capacityPopupContainerOuter').classList.add('showPopup');
      document.querySelector('.buyOnline').classList.add('buyOnline__active');
      document.body.style.overflow = 'hidden';
      document.getElementById('main').classList.add('variantPopup_active');
    },
    closecapacityPopupScreen: function () {
      this.capacityPopup = false;
      this.showPopup = false;
      window.eventBus.$emit('lrpretailer', false);
      document.getElementById('capacityPopupContainerOuter').classList.remove('showPopup');
      document.querySelector('.buyOnline').classList.remove('buyOnline__active');
      document.body.style.removeProperty('overflow');
      document.getElementById('main').classList.remove('variantPopup_active');
    },


  }
}

</script>
<style lang="scss" src="./lrp-retailer.scss"></style>
